import type { OpportunityStatus, RunnerStatusMarketDetails } from '@ps/isp-web-services-types';
import { runnerStatusMap } from '@ps/web-sports-enums';

export const getRunnerStatus = (status: OpportunityStatus): RunnerStatusMarketDetails =>
  runnerStatusMap[status];
